import { extend, useThree } from '@react-three/fiber'
import { Stage } from '@react-three/drei'
import React, { Suspense, useEffect } from 'react'
import ChairMesh from './components/chair'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import * as THREE from 'three'

extend({ OrbitControls })

export const Scene = ({ newMaterialOpt }) => {
  const {
    scene,
    camera,
    gl: { domElement, shadowMap },
  } = useThree()

  // Scene configuration;
  useEffect(() => {
    scene.background = new THREE.Color(0xcccccc)
    camera.fov = 50
  }, [])

  return (
    <>
      <orbitControls args={[camera, domElement]} minPolarAngle={Math.PI / 2.5} maxPolarAngle={Math.PI - Math.PI / 2} enableDamping={false} />

      <Suspense>
        <Stage adjustCamera={1.3} shadows={{ type: 'contact', opacity: 1.5, blur: 3 }} environment="forest" preset="soft" intensity={0.2}>
          <ChairMesh newMaterialOpt={newMaterialOpt} />
        </Stage>

        <ambientLight intensity={0.1} />
      </Suspense>
    </>
  )
}
